import { ISpykioContext } from "./contract";

export type ChatBoxType = {
  id: string;
  firstMessage: string;
  createdAt: string;
};

export enum ChatType {
  GENERAL = "general",
  CONTRACT = "contract",
  SUGGESTED_VENDORS = "searchVendor",
  SUGGESTED_CONTRACTS = "searchContract",
}

export type ContractChoice = string[];

export type VendorChoice = {
  vendorID: string;
  email: string;
  description: string;
  website: string;
  address: string;
};

export enum TabType {
  home = "home",
  history = "history",
  chatBox = "chatBox",
}

export type Annotation = {
  type: string;
  text: string;
  start_index: number;
  end_index: number;
  file_citation: any;
};

export type AssistantMessage = {
  id: string;
  object: string;
  created_at: number;
  assistant_id: string;
  thread_id: string;
  run_id: string;
  role: string;
  content: {
    type: string;
    text: {
      value: string;
      annotations: Annotation[];
    };
  }[];
  attachments: any[];
  metadata: any;
};

export enum Author {
  BOT = "bot",
  USER = "user",
}

export type NewChatBoxMessage = {
  type: ChatType;
  message: string;
};

export type IChatMessage = {
  role: "system" | "user" | "assistant";
  content: string;
  created_at?: number;
  sources?: ISpykioContext[];
};

export type IThread = {
  id?: string;
  contractId: string;
  documentId: string;
  userId: string;
  tenantId: string;
  messages: IChatMessage[];
};
